var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_806_2873)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_806_2873)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    transform: "translate(5 2.68152)",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0954 21.1021C26.612 21.1021 27.9129 19.7417 27.9129 17.9873C27.9129 16.2552 26.6045 14.9542 25.0954 14.9542C23.5789 14.9542 22.2705 16.2849 22.2705 18.0022C22.2705 19.7417 23.5715 21.1021 25.0954 21.1021ZM16.985 21.2657C18.3008 21.2657 19.4382 20.0762 19.4382 18.5448C19.4382 17.0357 18.3008 15.9132 16.985 15.9132C15.6692 15.9132 14.5243 17.0655 14.5243 18.5597C14.5243 20.0762 15.6617 21.2657 16.985 21.2657ZM33.1985 21.2657C34.5217 21.2657 35.6591 20.0762 35.6591 18.5597C35.6591 17.0655 34.5143 15.9132 33.1985 15.9132C31.8901 15.9132 30.7453 17.0357 30.7453 18.5448C30.7453 20.0762 31.8826 21.2657 33.1985 21.2657ZM13.0821 27.6217H18.3974C17.654 26.5587 18.5238 24.4251 20.0626 23.2357C19.2821 22.7153 18.2785 22.3362 16.9775 22.3362C13.8181 22.3362 11.8184 24.6704 11.8184 26.6033C11.8184 27.2574 12.1678 27.6217 13.0821 27.6217ZM37.1013 27.6217C38.0157 27.6217 38.3651 27.2574 38.3651 26.6033C38.3651 24.6704 36.3653 22.3362 33.2059 22.3362C31.905 22.3362 30.9014 22.7153 30.1208 23.2357C31.6596 24.4251 32.5294 26.5587 31.786 27.6217H37.1013ZM20.6797 27.6217H29.4963C30.6189 27.6217 31.0129 27.2946 31.0129 26.6702C31.0129 24.8563 28.7381 22.3585 25.088 22.3585C21.4454 22.3585 19.1631 24.8563 19.1631 26.6702C19.1631 27.2946 19.5571 27.6217 20.6797 27.6217Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 5.75,
    y: 3.43152,
    width: 38.5,
    height: 38.5,
    rx: 19.25,
    stroke: "white",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_806_2873",
    x: 0.454545,
    y: 0.408791,
    width: 49.0909,
    height: 49.0909,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.27273
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.27273
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0666667 0 0 0 0 0.0666667 0 0 0 0 0.0666667 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_806_2873"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_806_2873",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_806_2873"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 2.68152,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherall);
export default __webpack_public_path__ + "static/media/Other all.29406f29a49b520a2173bef673ac1a87.svg";
export { ForwardRef as ReactComponent };